export enum PartnerProviderType {
  BOOKING_COM = "BOOKING_COM",
  VIATOR = "VIATOR",
}

export interface PartnerSettings {
  id: string;
  hotelId: string;
  provider: PartnerProviderType;
  enabled: boolean;
  destinationId?: string;
  destinationName?: string;
  destinationType?: string;
  destination?: {
    destinationId: string | null;
    destinationName: string | null;
    destinationType: string | null;
    regionName: string | null;
    countryName: string | null;
    countryCode: string | null;
    flagEmoji: string | null;
  } | null;
  autoSyncEnabled: boolean;
  lastSyncAt?: string;
  hotelFeePercent?: number;
  metadata?: Record<string, unknown>;
  lastMonthRevenue?: number;
  createdAt: Date;
  updatedAt: Date;
}

export interface UpdatePartnerSettingsRequest {
  enabled?: boolean;
  destinationId?: string;
  destinationName?: string;
  destinationType?: string;
  autoSyncEnabled?: boolean;
}

export interface PartnerDestination {
  destinationId: string;
  name: string;
  type: string;
  parentId?: string;
  latitude?: number;
  longitude?: number;
}

export enum ServiceStatus {
  ACTIVE = "ACTIVE",
  INACTIVE = "INACTIVE",
}

export enum ServiceAvailability {
  WHOLE_WEEK = "WHOLE_WEEK",
  WEEKDAYS = "WEEKDAYS",
  WEEKENDS = "WEEKENDS",
}

export interface PartnerServiceCategory {
  tagId: number;
  name: string;
}

export interface PartnerServiceImage {
  url: string;
  caption?: string;
  isCover?: boolean;
}

export interface PartnerServiceFlags {
  freeCancellation?: boolean;
  likelyToSellOut?: boolean;
  skipTheLine?: boolean;
}

export interface PartnerServiceListItem {
  id: string;
  name: string;
  description: string;
  price?: number;
  currency?: string;
  images: PartnerServiceImage[];
  rating?: number;
  reviewCount?: number;
  categories: PartnerServiceCategory[];
  provider: PartnerProviderType;
  partnerProductCode: string;
  partnerServiceUrl?: string;
  flags: PartnerServiceFlags;
  status: ServiceStatus;
  isRecommended?: boolean;
  availableDays?: ServiceAvailability[];
}

export interface PriceRange {
  min: number | null;
  max: number | null;
}

export interface PartnerServiceFilterOptions {
  categories: PartnerServiceCategory[];
  priceRange: PriceRange | null;
}

export interface PartnerServicesListResponse {
  data: PartnerServiceListItem[];
  total: number;
  hasMore: boolean;
}

export interface PartnerServicesFilters {
  search?: string;
  tagIds?: number[];
  status?: ServiceStatus[];
  minPrice?: number;
  maxPrice?: number;
  isRecommended?: boolean;
  availability?: ServiceAvailability;
  page?: number;
  limit?: number;
}
